module.exports = __webpack_public_path__ + "img/white@2x.ad4fb3e1.png";